import ajab from "./ajab.png";
import tars from "./tars.png";
import cliper from "./cliper.png";
import shad from "./shad.png";
import item from "./item.png";
import item1 from "./item1.png";
import item2 from "./item2.png";
import item3 from "./item3.png";
import item4 from "./item4.png";
import item5 from "./item5.png";
import item6 from "./item6.png";
import item7 from "./item7.png";
import item8 from "./item8.png";
import item9 from "./item9.png";
import item10 from "./item10.png";
import item11 from "./item11.png";
import dr from "./dr.jpg"
import hs from "./hs.jpg"
import imen from "./imen.jpg"
import p9 from "./p9.jpg"
import p8 from "./p8.jpg"
import p89 from "./p89.png"

import q81 from "./8th/1.png"
import q82 from "./8th/2.png"
import q83 from "./8th/3.png"
import q84 from "./8th/4.png"
import q85 from "./8th/5.png"
import q86 from "./8th/6.png"
import q87 from "./8th/7.png"
import q88 from "./8th/8.png"
import q89 from "./8th/9.png"
import q810 from "./8th/10.png"


import q91 from "./9th/1.png"
import q92 from "./9th/2.png"
import q93 from "./9th/3.png"
import q94 from "./9th/4.png"
import q95 from "./9th/5.png"
import q96 from "./9th/6.png"
import q97 from "./9th/7.png"
import q98 from "./9th/8.png"
import q99 from "./9th/9.png"
import q910 from "./9th/10.png"

import acnav from "./academy-nav.jpg"

const q8 = [
    q81,
    q82,
    q83,
    q84,
    q85,
    q86,
    q87,
    q88,
    q89,
    q810,
]

const q9 = [
    q91,
    q92,
    q93,
    q94,
    q95,
    q96,
    q97,
    q98,
    q99,
    q910,
]

export { ajab, tars, cliper, shad, item, item1, item2, item10, item11, item3, item4, item5, item6, item7, item8, item9, dr, hs, imen, p8, p9, p89, q8, q9, acnav };
